
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Coins, AlertCircle, Loader2 } from 'lucide-react';
import PlanBadge from './subscription/PlanBadge';
import PlanFeatures from './subscription/PlanFeatures';
import useSubscription from './subscription/useSubscription';
import SubscriptionActions from './subscription/SubscriptionActions';
import { Button } from '@/components/ui/button'; // Added this import

const SubscriptionInfo = () => {
  const { 
    userCredits,
    isLoadingCredits,
    handleBuyCredits,
    refetchCredits
  } = useSubscription();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <div className="flex items-center">
            <Coins className="mr-2 h-5 w-5 text-amber-500" />
            Kreditet dhe Plani Juaj
          </div>
          <Button variant="ghost" size="sm" onClick={() => refetchCredits()} disabled={isLoadingCredits} className="text-xs">
            {isLoadingCredits ? <Loader2 className="h-3 w-3 animate-spin" /> : "Rifresko"}
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoadingCredits && !userCredits ? (
          <div className="space-y-4">
            <Skeleton className="h-8 w-1/2" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-10 w-1/3" />
          </div>
        ) : userCredits ? (
          <div className="space-y-4">
            <PlanBadge 
              freeListingsRemaining={userCredits.free_listings_remaining}
              purchasedListingsCredits={userCredits.purchased_listings_credits || 0}
              freeListingsUsed={userCredits.free_listings_used}
              totalListingsUsed={userCredits.total_listings_used || 0}
              defaultFreeListings={userCredits.default_free_listings}
            />
            <PlanFeatures />
            <SubscriptionActions 
              onBuyCredits={handleBuyCredits}
            />
          </div>
        ) : (
          <div className="flex flex-col items-center py-4 text-center">
            <AlertCircle className="h-10 w-10 text-yellow-500 mb-2" />
            <div className="text-gray-500 italic">
              Nuk u gjetën të dhëna për kreditet. Ju lutemi provoni të rifreskoni ose kthehuni më vonë.
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SubscriptionInfo;
